import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import '@/assets/site.css';

@Component({components: {}})
export default class MenuApp extends Vue {
  public $refs: any;

  public goToView(pRouteViewName: string ) {
    this.$router.push({ name: pRouteViewName })
  }
  public mounted() {
    const vueInst = this;
  }
}
